var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component model-card"},[_c('router-link',{attrs:{"to":'/model/' + _vm.name}},[_c('div',{staticClass:"box is-radiusless"},[_c('img',{attrs:{"src":_vm.image,"alt":"Image","width":_vm.width}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }